import { createContext } from 'react';
export const ToastContext = createContext(undefined);
ToastContext.displayName = 'ToastContext';
//# sourceMappingURL=ToastContext.js.map